export interface IUserProfile {
    first_name: string;
    last_name: string;
    email_notification_digest_type_id: EmailNotificationDigestType;
    facts: Array<IUserFact>;
}

export interface IUser extends IUserProfile {
    id: number;
    profile_image_url: string;
    email: string;
    created_at: Date;
    last_login_at: Date | null;
}

export interface IUserFact {
    value: string | Date;
    title: UserFactType;
}

export enum UserFactType {
    Nickname = 'Nickname',
    BirthPlace = 'Birth Place',
    BirthDate = 'Birth Date',
    CurrentPlace = 'Current Place',
}

export enum EmailNotificationDigestType {
    None,
    Weekly,
    Daily,
}



// WEBPACK FOOTER //
// ./src/Models/IUser.ts